// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function Finance(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h1", {
                children: "Финансовые продукты Бухты для эффективности бизнеса",
                className: "h3 lg:h1 text-start lg:flex lg:m-auto lg:w-252 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Получите кредитование на оборотные средства от Бухты, платите процент с выручки и управляйте сотрудниками с админки",
                className: "paragraph-large lg:h5 text-start lg:flex lg:m-auto mt-4 lg:mt-6 lg:w-252 text-black-landing"
              }),
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                classes: {
                  hd: "mt-6 lg:mt-10",
                  tl: /* [] */ 0
                },
                label: "Оставить заявку",
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              })
            ],
            className: "flex px-6 flex-col mx-auto items-start z-1"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              className: "bg-finance h-[292px] sm:h-[1048px]"
            }),
            className: "relative mt-[-25px] sm:mt-[-100px] z-0"
          })
        ],
        className: "flex flex-col h-auto sm:h-[1272px]"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Бухта Овердрафт",
                className: "h4 lg:h2 sm:text-center text-black-landing"
              }),
              deviceType === "mobile" ? JsxRuntime.jsxs("p", {
                  children: [
                    "Возможность уходить в минус,",
                    JsxRuntime.jsx("br", {}),
                    "по лимиту, без постоянных одобрений и задержек"
                  ],
                  className: "paragraph-large h-light text-black-landing mt-4"
                }) : JsxRuntime.jsxs("p", {
                  children: [
                    "Возможность уходить в минус, по лимиту",
                    JsxRuntime.jsx("br", {}),
                    "без постоянных одобрений и задержек"
                  ],
                  className: "paragraph-large h-light text-[22px] text-center  text-black-landing mt-4"
                })
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h5", {
                    children: "Быстрое получение денег",
                    className: "h6 lg:h5 mb-2 text-black-landing"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Получайте столько денег сколько нужно, в автоматическом режиме по установленным настройкам, платите только за использованную сумму, без переплаты за лишний кредит",
                    className: "paragraph-small lg:paragraph text-gray-landing w-[327px] sm:w-[400px]"
                  })
                ]
              }),
              deviceType === "mobile" ? JsxRuntime.jsx("img", {
                  className: "w-[327px] h-[200px] mt-2",
                  src: StaticAsset.src("/static/images/overdraft-mobile.png")
                }) : JsxRuntime.jsx("img", {
                  className: "-mt-7",
                  src: StaticAsset.src("/static/images/overdraft.svg")
                })
            ],
            className: "flex flex-col-reverse sm:flex-row lg:gap-6 sm:pt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h5", {
                        children: "Все в онлайне",
                        className: "h6 lg:h5 mb-2 text-black-landing"
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Оформите овердрафт в личном кабинете без поездки в офис, залогов и поручителей",
                        className: "paragraph-small lg:paragraph text-gray-landing w-[327px] sm:w-[400px]"
                      })
                    ]
                  }),
                  deviceType === "mobile" ? JsxRuntime.jsx("img", {
                      className: "w-[327px] h-[200px]",
                      src: StaticAsset.src("/static/images/online-connect-mobile.png")
                    }) : JsxRuntime.jsx("img", {
                      className: "mt-6 w-[272px]",
                      src: StaticAsset.src("/static/images/online-connect.svg")
                    })
                ],
                className: "flex flex-col-reverse sm:flex-col w-[416px] lg:p-10"
              }),
              JsxRuntime.jsx("div", {
                className: "border-r border-gray-pale"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h5", {
                        children: "Для оплаты налогов",
                        className: "h6 lg:h5 mb-2 text-black-landing"
                      }),
                      JsxRuntime.jsx("p", {
                        children: "7 дней без вознаграждения, через наш сервис",
                        className: "paragraph-small lg:paragraph text-gray-landing sm:w-[400px]"
                      })
                    ]
                  }),
                  deviceType === "mobile" ? JsxRuntime.jsx("img", {
                      className: "mt-6 w-[327px] h-[200px]",
                      src: StaticAsset.src("/static/images/seven-days-mobile.png")
                    }) : JsxRuntime.jsx("img", {
                      className: "mt-6",
                      src: StaticAsset.src("/static/images/seven-days.svg")
                    })
                ],
                className: "flex flex-col-reverse sm:flex-col w-[416px] pt-10 pb-2"
              })
            ],
            className: "flex flex-col sm:flex-row lg:border-t border-gray-pale lg:w-[1008px] lg:justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                classes: {
                  hd: "m-auto lg:mt-2",
                  tl: /* [] */ 0
                },
                label: "Подключить",
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              }),
              JsxRuntime.jsx("span", {
                children: "Уже пользуются 125 предпринимателей",
                className: "text-gray-landing text-center sm:text-start text-[14px]"
              })
            ],
            className: "flex w-full flex-col items-center gap-4"
          })
        ],
        className: "bg-white flex flex-col items-start sm:items-center gap-8 px-6 py-10 sm:px-[112px] sm:py-[120px]"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Бухта Факторинг",
                className: "h4 lg:h2 sm:text-center text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Покупателю выгодно работать   с отсрочкой платежа — он успеет продать товар и оплатить поставку за счет вырученных средств. А у поставщика за это время возникают кассовые разрывы. Ему не хватает денег — нужно закупать новый товар, платить зарплату, налоги.",
                className: "paragraph sm:text-center text-[18px] sm:text-[16px] text-black-landing self-stretch leading-[28px] sm:text-gray-landing mt-4 max-w-[800px]"
              })
            ]
          }),
          JsxRuntime.jsx("img", {
            alt: "buhta-factoring",
            src: StaticAsset.src("/static/images/factoring.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Сохранить заказчиков и не копить дебиторскую задолженность поможет Бухта Факторинг",
            className: "text-[18px] sm:h-light text-center sm:text-start text-black-landing"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                classes: {
                  hd: "flex justify-center m-auto ",
                  tl: /* [] */ 0
                },
                label: "Подключить",
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              }),
              JsxRuntime.jsx("span", {
                children: "Уже пользуются 125 предпринимателей",
                className: "text-gray-landing text-center text-[14px]"
              })
            ],
            className: "flex w-full flex-col gap-4"
          })
        ],
        className: "bg-white flex flex-col items-start sm:items-center gap-10 sm:gap-16 px-6 py-10 sm:px-[112px] sm:py-[120px]"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h4", {
                children: "Payroll финансы",
                className: "h4 lg:h3 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Автоматизируйте выплату заработной платы и сделайте ее доступной по запросу",
                className: "paragraph-large lg:h-light mt-2 text-black-landing"
              })
            ],
            className: "px-6"
          }),
          JsxRuntime.jsxs("ul", {
            children: [
              JsxRuntime.jsxs("li", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/check-green-white.svg")
                  }),
                  "Возможность выплаты заработной платы в постоплату"
                ],
                className: "flex items-start sm:items-center gap-2 text-black-landing"
              }),
              JsxRuntime.jsxs("li", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/check-green-white.svg")
                  }),
                  "Удобная работа с кадрами"
                ],
                className: "flex items-start sm:items-center gap-2 text-black-landing"
              }),
              JsxRuntime.jsxs("li", {
                children: [
                  JsxRuntime.jsx("img", {
                    src: StaticAsset.src("/static/icons/check-green-white.svg")
                  }),
                  "Сокращение времени на обработку\n              на 30%"
                ],
                className: "flex items-start sm:items-center gap-2 text-black-landing"
              })
            ],
            className: "flex flex-col gap-4 px-6 z-11"
          }),
          JsxRuntime.jsx("p", {
            children: "Стоимость услуги зависит от характеристик предприятия",
            className: "paragraph-small lg:paragraph px-6 text-[14px] sm:text-[18px] text-gray-landing z-11"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              className: "lg:w-[1440px] md:h-[740px] w-[327px] h-[250px] bg-payroll"
            }),
            className: "sm:relative sm:ml-[-210px] sm:mt-[-120px] sm:z-0"
          })
        ],
        className: "bg-white flex flex-col gap-10 items-start pt-10 sm:px-[360px] sm:py-[80px]"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Попробуйте финансовые продукты Бухты прямо сейчас",
                className: "h4 lg:h2 text-white text-center w-[327px] lg:text-left lg:w-[723px]"
              }),
              JsxRuntime.jsx("p", {
                children: "Отправьте заявку на подключение, расскажите нам о своем бизнесе и мы подберем для вас выгодные условия",
                className: "paragraph lg:paragraph-large opacity-64 text-white text-center lg:text-left lg:w-130 mt-2"
              }),
              JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
                classes: {
                  hd: "flex justify-center sm:justify-start mt-6 lg:mt-10",
                  tl: /* [] */ 0
                },
                label: "Начать пользоваться",
                onClick: (function (param) {
                  Buhta_landing__EventHandlers.scrollToFooter(deviceType);
                })
              })
            ],
            className: "flex flex-col items-center sm:items-start  py-10 lg:pt-16 lg:pb-19 px-6 sm:px-48 lg:pl-18 lg:pr-0"
          }),
          className: "sm:w-304 lg:flex lg:m-auto lg:rounded-sm bg-black-landing"
        }),
        className: "bg-white lg:pt-20 -pt-10 lg:pb-40"
      })
    ],
    className: "pt-16 lg:pt-40 sm:px-48 lg:px-0 bg-gray-pale overflow-x-hidden"
  });
}

const make = Finance;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
